import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ICerberusToken } from 'src/app/interfaces/icerberus-token/icerberus-token.interface';
import { State } from 'src/app/store';
import { environmentSelector } from 'src/app/store/global/global.selectors';

@Injectable({
    providedIn: 'root',
})
export class LoginService {
    constructor(private http: HttpClient, private store: Store<State>) {}

    public login(email: string, password: string): Observable<ICerberusToken> {
        return this.store
            .select(environmentSelector)
            .pipe(switchMap((env) => this.http.post(`${env.baseUrl}/cerberus/signin`, { email, password }, { headers: { 'x-organisation': 'ALL' } }))) as Observable<ICerberusToken>;
    }
}
